import { getRequest, postRequest, putRequest } from "./axiosClient";

export const getPhotos = () => getRequest(`carts/getPhotos`);
export const changeCount = (id, data) => postRequest(`carts/setCount/${id}`, data);
export const selectPhoto = (id, data) => postRequest(`carts/selectPhoto/${id}`, data);